/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const PopoverList = (props) => {
    const classNames = [
        'c-popover__container-list',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];

    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PopoverList.propTypes = propTypes;

PopoverList.defaultProps = defaultProps;

export default PopoverList;
